import { colors } from "widgets/utils";

import { drawPhenotypeBullet } from "./phenotypes-renderer.ts";

/**
 * This draw the group header title. Phenotypes, genome name...
 * Always aligned on the left side of the main canvas. Not shifted.
 */
export function drawGroupHeader(
  label: string,
  phenotypes: { color: string }[],
  ctx: CanvasRenderingContext2D,
  isHighlighted = false,
) {
  if (!ctx) return;

  const numBullets = phenotypes.slice(0, 3);
  const bulletSpacing = 9;
  const textPadding = 5;
  const coordinateOffset = 1;
  const clearHeight = 18;

  ctx.save();
  ctx.textAlign = "left";
  ctx.font = "12px Roboto Flex, sans-serif";
  const textWidth = ctx.measureText(label).width;
  const clearWidth = textWidth + textPadding + (textPadding + numBullets.length * bulletSpacing);

  ctx.fillStyle = isHighlighted ? colors.butterScotchLight : "white";
  ctx.globalAlpha = isHighlighted ? 0.7 : 1;
  ctx.fillRect(0, 1, clearWidth, clearHeight);

  const centerY = clearHeight / 2;
  const textX = textPadding + numBullets.length * bulletSpacing;
  const textY = centerY + ctx.measureText(label).actualBoundingBoxAscent / 2 - coordinateOffset;

  ctx.fillStyle = colors.primaryMain;
  ctx.globalAlpha = 1;
  ctx.fillText(label, textX, Math.ceil(textY + 1));

  numBullets.forEach((phenotype, i) => {
    const bulletX = textPadding + i * bulletSpacing;
    drawPhenotypeBullet(bulletX, centerY, phenotype.color, ctx);
  });

  ctx.restore();
}
